import React from 'react'
import { Outlet } from 'react-router-dom'

import DimensionListPage from './pages/DimensionListPage'
import DimensionWeightsPage from './pages/DimensionWeightsPage'

export const routes = {
  admin: [
    {
      path: 'dimensoes',
      label: 'Dimensōes',
      element: <Outlet />,
      children: [
        { path: '', element: <DimensionListPage /> },
        {
          path: 'alterar-ponderacoes',
          label: 'Alterar Ponderaçōes',
          element: <DimensionWeightsPage />
        }
      ]
    }
  ]
}

export default routes
